import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {FabDateFilterOperator, FabStringFilterOperator} from "@fabric/components/table-filter";
import {IdDescModel} from "../../models/RemitoVehicleCreationDetails";
import {FabTableState, filterStateChange, process} from "@fabric/components/table-filter/data-query";
import {HttpErrorResponse} from "@angular/common/http";
import {VehRemPrinted} from "../../models/VehRemPrinted";
import {FormControl, FormGroup} from "@angular/forms";
import {RemitoVehicleService} from "../../services/remito-vehicle.service";
import {NotificationService} from "../../services/notification.service";
import {concat, map, Observable, ObservableInput, startWith} from "rxjs";
import {ErrorCodes} from "../../constants/ErrorCodes";

@Component({
  selector: 'app-vehicle-remitos-printed',
  templateUrl: './vehicle-remitos-printed.component.html',
  styleUrls: ['./vehicle-remitos-printed.component.scss']
})
export class VehicleRemitosPrintedComponent implements OnInit {

  displayedColumns: string[] = [
    'nombre', 'fecha', 'tamano', 'impresoras', 'sendButton'
  ];
  dataSource: MatTableDataSource<VehRemPrinted> = new MatTableDataSource<VehRemPrinted>();
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  @ViewChild(MatSort) set matSort(sort: MatSort) { this.dataSource.sort = sort; }
  showVehRemData: boolean = false;
  operators: FabStringFilterOperator[] = ['contains'];
  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  errors: HttpErrorResponse[] = [];
  nombreControl = new FormControl('');
  fechaControl = new FormControl<Date | null>(null);

  vehRemitosPrintedForm: FormGroup = new FormGroup({
    nombre: this.nombreControl,
    fecha: this.fechaControl,
  })

  nombre: IdDescModel[] = [];
  validNombre: string[] = [];
  filteredNombre: Observable<IdDescModel[]> | undefined;
  impresoras: IdDescModel[] = [];

  printedRemitos: VehRemPrinted[] = [];
  vehRemPrinted: VehRemPrinted;
  validationErrorMessage: string = '';


  constructor(private remitoVehicleService: RemitoVehicleService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(){
    let obs: ObservableInput<any>[] = [];
    obs.push(this.remitoVehicleService.getDetails("_").pipe(map((response) => {
      if (response) {
        // @ts-ignore
        this.createDetailsData = response;
        for (let i = 0; i < response.pdfName.length; i++) {
          this.nombre.push(response.pdfName[i]);
          this.validNombre.push(response.pdfName[i].desc);
        }
        this.validNombre.push('');
        this.populateNombre();
        for (let i = 0; i < response.impresoras.length; i++) {
          this.impresoras.push(response.impresoras[i]);
        }
      }
    })));
    concat(...obs).subscribe({
      next: undefined,
      error: undefined,
      complete: () => {}
    });
  }

  populateNombre() {
    this.filteredNombre = this.nombreControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        // @ts-ignore
        const nombreValue = typeof value === 'string' ? value : value?.desc;
        return nombreValue ? this.nombreFiltering(nombreValue as string) : this.nombre.slice();
      }),
    );
  }

  private nombreFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.nombre.filter(option => option.desc.toLowerCase().includes(filterValue));
  }

  public impresorasFiltering(name: string): IdDescModel[] {
    return name && (this.impresoras.filter(option => option.desc.toLowerCase().includes(name) || option.id.toLowerCase().includes(name))) || this.impresoras;
  }

  search() {
    this.getSearchData();
    this.validateSearchData();

    if (this.validationErrorMessage != '') {
      this.notificationService.open(this.validationErrorMessage, 'error');
    } else if(this.vehRemitosPrintedForm.invalid) {
      this.notificationService.open("Campos de búsqueda Inválido. Por favor complete los campos requeridos", 'error');
    } else {
      this.remitoVehicleService.getPrintedVehRemitos(this.vehRemPrinted).subscribe((response) => {
        this.printedRemitos = response;
        this.displayData();
      });
    }
  }

  displayData() {
    if (this.printedRemitos.length == 0) {
      //No results found related to your search, Please try different criteria.
      this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');
      this.hideTable();
    } else {
      this.dataSource.data = process(this.printedRemitos as any[], this.state);
      this.showVehRemData = true;
      this.setPagination();
    }
  }

  getSearchData() {
    this.vehRemPrinted = new VehRemPrinted();

    this.getNombreSearchCriteria();
    this.getFechaSearchCriteria();
  }

  validateSearchData() {

    this.validationErrorMessage = '';

    if (this.vehRemPrinted.nombre == null && this.vehRemPrinted.fecha == null) {

      this.validationErrorMessage = 'Ingrese al menos UN criterio de búsqueda válido para continuar!';
      this.hideTable();
    }
  }

  getNombreSearchCriteria() {
    if (this.nombreControl.value != '') {
      this.vehRemPrinted.nombre = this.nombreControl.value;
    } else {
      this.vehRemPrinted.nombre = null;
    }
  }

  getFechaSearchCriteria() {
    if (this.fechaControl.value == null) {
      this.vehRemPrinted.fecha = null;
    } else {
      // @ts-ignore
      this.vehRemPrinted.fecha = this.fechaControl.value.toISOString().slice(0, 10);
    }
  }

  sendPrintedRemito(vehRemPrinted: VehRemPrinted){
      if(vehRemPrinted.impresoras != undefined) {
        const impresoras = vehRemPrinted.impresoras.split('-');
        const impresorasCode = impresoras[0].trim();
        this.remitoVehicleService.sendPrintedVehRemitos(vehRemPrinted.nombre, impresorasCode).subscribe({
          next: (response) => {
            this.notificationService.open(ErrorCodes.SEND_PRINTED_REMS_SUCCESS, 'success');
            const indToUpdate = this.dataSource.data.findIndex(vehPrinted=> vehPrinted.nombre === vehRemPrinted.nombre);
            if(indToUpdate !== -1){
              this.dataSource.data[indToUpdate].impresoras = "";
            }
          },
          error: (error) => {
            this.errors.push(error);
            this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
          }
        });
      }
      else{
        vehRemPrinted.isInvalid = true;
      }
    }

  onChangeImpresoras(vehRemPrinted: VehRemPrinted) {
    vehRemPrinted.isInvalid = false;
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.filterData();
  }

  private filterData() {
    this.dataSource.data = process(this.printedRemitos, this.state)
  }

  hideTable() {
    this.showVehRemData = false;
    this.dataSource.data = [];
  }

  setPagination() {
    this.dataSource.paginator = this.paginator;
  }


}
